import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit, signal } from '@angular/core';

import { EventType, Router, RouterOutlet } from '@angular/router';
import { Subscriptions, TimeGenerator } from '@unicup-ticketing/utils';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map, tap } from 'rxjs';
import { HamburgerOverlayComponent } from '../components/hamburger-overlay/hamburger-overlay.component';
import { MobileMenuComponent } from '../components/mobile-menu/mobile-menu.component';
import { HeaderComponent } from '../components/header/header.component';

@Component({
  selector: 'ticketing-frame',
  imports: [RouterOutlet, MobileMenuComponent, HamburgerOverlayComponent, HeaderComponent],
  templateUrl: './ticketing-frame.component.html',
  styleUrl: './ticketing-frame.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppFrameComponent implements OnInit, OnDestroy {
  mobileMenuOpen = signal<boolean>(false);
  private readonly router = inject(Router);
  private readonly timeGenerator = inject(TimeGenerator);
  protected readonly currentYear = toSignal(
    this.timeGenerator.$NowEverySecond.pipe(map(timeStamp => timeStamp.getFullYear())),
  );
  private readonly subs = new Subscriptions();

  ngOnInit(): void {
    this.subs.put(
      this.router.events
        .pipe(
          filter(event => event.type === EventType.NavigationEnd || event.type === EventType.NavigationSkipped),
          tap(() => this.mobileMenuOpen.set(false)),
        )
        .subscribe(),
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribeAll();
  }
}
